var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select, Table } from 'semantic-ui-react';
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { priceColumn } from "../rna-fish/EditKitForm";
import { ComponentPriceDisplay } from "../rna-fish/ProbeSetForm";
var BufferForm = /** @class */ (function (_super) {
    __extends(BufferForm, _super);
    function BufferForm(props) {
        var _this = _super.call(this, props) || this;
        _this.buffersHelp = React.createElement(React.Fragment, null,
            React.createElement(Help, null,
                "Different sample types require different amounts of antibody and amplification buffers. For the following sample types, 20 experiments require approximately:",
                React.createElement("p", null),
                React.createElement(Table, { celled: true, className: 'exp-volume-table', striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Sample type"),
                            React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                            React.createElement(Table.HeaderCell, null, "Antibody Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "Amplifier Buffer (mL)"))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Whole-mount zebrafish embryos (28 hpf)"),
                            React.createElement(Table.Cell, null, "250"),
                            React.createElement(Table.Cell, null, "20"),
                            React.createElement(Table.Cell, null, "17")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "FFPE tissue section"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "6")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Mammalian cells on a slide"),
                            React.createElement(Table.Cell, null, "300"),
                            React.createElement(Table.Cell, null, "18"),
                            React.createElement(Table.Cell, null, "12")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample in solution"),
                            React.createElement(Table.Cell, null, "250"),
                            React.createElement(Table.Cell, null, "15"),
                            React.createElement(Table.Cell, null, "10")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample on a slide"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "6"))))));
        _this.goldBuffersHelp = React.createElement(React.Fragment, null,
            React.createElement(Help, null,
                "For the following sample types with representative reaction volumes, 20 experiments require approximately:",
                React.createElement("p", null),
                React.createElement(Table, { celled: true, striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Sample type"),
                            React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Antibody Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Antibody Wash Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 Gold Amplifier Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 Gold Amplifier Wash Buffer (mL)"))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "6"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "6"),
                            React.createElement(Table.Cell, null, "500")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample in solution (e.g., whole-mount embryo or cells in suspension)"),
                            React.createElement(Table.Cell, null, "200"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "20"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "40")))),
                React.createElement("p", null),
                "Note: HCR\u2122 Gold Amplifier Wash Buffer is provided at 4x; dilute to 1x using UltraPure H2O prior to use. Hence, purchasing 50 mL of HCR\u2122 Gold Amplifier Wash Buffer (provided at 4x) yields 200 mL of 1x HCR\u2122 Gold Amplifier Wash Buffer (sufficient for approximately 100 experiments for a sample in solution using the table above)."));
        _this.volumeOptions = function (b) {
            return b.volumeMls.map(function (v) {
                return {
                    text: v.valueMl > 0 ? v.valueWithUnit : 'None',
                    value: v.valueMl
                };
            });
        };
        _this.onAntibodyChange = function (_, data) {
            _this.onVolumeChange(_this.props.catalog.antibody, data, 'antibody');
        };
        _this.onGoldAntibodyChange = function (_, data) {
            _this.onVolumeChange(_this.props.catalog.goldAntibody, data, 'antibody');
        };
        _this.onAntibodyWashChange = function (_, data) {
            _this.onVolumeChange(_this.props.catalog.antibodyWash, data, 'antibodyWash');
        };
        _this.onAmplificationChange = function (_, data) {
            _this.onVolumeChange(_this.props.catalog.amplification, data, 'amplification');
        };
        _this.onGoldAmpWashChange = function (_, data) {
            _this.onVolumeChange(_this.props.catalog.goldAmpWash, data, 'goldAmpWash');
        };
        _this.onVolumeChange = function (b, data, field) {
            var val = b.volumeMls.find(function (v) { return v.valueMl === data.value; });
            if (val === undefined) {
                throw new RangeError("Could not find volume " + data.value);
            }
            var update = {};
            update[field] = val;
            _this.props.onBufferChange(update, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onBufferChange(function (oldState) { return ({ customPrice: newStateFn(oldState.customPrice) }); }, callback);
        };
        return _this;
    }
    BufferForm.prototype.render = function () {
        return React.createElement(Grid, { columns: 4, stackable: true },
            this.props.legacy ? React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errorPath: '/buffersComponent/antibodyBufferMl', showErrors: this.props.showErrors, errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "Antibody Buffer ",
                                this.buffersHelp), labelFor: 'buffer-probe-antibody' },
                            React.createElement(Select, { name: 'buffer-probe-antibody', onChange: this.onAntibodyChange, options: this.volumeOptions(this.props.catalog.antibody), value: this.props.bufferState.antibody.valueMl }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errorPath: '/buffersComponent/amplificationBufferMl', errors: this.props.errors, showErrors: this.props.showErrors, labelContent: React.createElement(React.Fragment, null,
                                "Amplifier Buffer (v3.0) ",
                                this.buffersHelp), labelFor: 'buffer-amplification' },
                            React.createElement(Select, { name: 'buffer-amplification', onChange: this.onAmplificationChange, options: this.volumeOptions(this.props.catalog.amplification), value: this.props.bufferState.amplification.valueMl }))),
                    React.createElement(Grid.Column, null),
                    priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.effectivePriceCents, listPriceCents: this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents))) : React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errorPath: '/buffersComponent/antibodyBufferMl', showErrors: this.props.showErrors, errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "HiFi Antibody Buffer ",
                                this.goldBuffersHelp), labelFor: 'buffer-probe-antibody' },
                            React.createElement(Select, { name: 'buffer-probe-antibody', onChange: this.onGoldAntibodyChange, options: this.volumeOptions(this.props.catalog.goldAntibody), value: this.props.bufferState.antibody.valueMl }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errorPath: '/buffersComponent/antibodyWashBufferMl', showErrors: this.props.showErrors, errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "HiFi Antibody Wash Buffer ",
                                this.goldBuffersHelp), labelFor: 'buffer-antibody-wash' },
                            React.createElement(Select, { name: 'buffer-antibody-wash', onChange: this.onAntibodyWashChange, options: this.volumeOptions(this.props.catalog.antibodyWash), value: this.props.bufferState.antibodyWash.valueMl })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errorPath: '/buffersComponent/amplificationBufferMl', errors: this.props.errors, showErrors: this.props.showErrors, labelContent: React.createElement(React.Fragment, null,
                                " Gold Amplifier Buffer ",
                                this.goldBuffersHelp), labelFor: 'buffer-amplification' },
                            React.createElement(Select, { name: 'buffer-amplification', onChange: this.onAmplificationChange, options: this.volumeOptions(this.props.catalog.amplification), value: this.props.bufferState.amplification.valueMl }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errorPath: '/buffersComponent/goldAmpWashBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "Gold Amplifier Wash Buffer ",
                                this.goldBuffersHelp), labelFor: 'gold-buffer-wash-amplification', showErrors: this.props.showErrors },
                            React.createElement(Select, { name: 'gold-buffer-wash-amplification', onChange: this.onGoldAmpWashChange, options: this.volumeOptions(this.props.catalog.goldAmpWash), value: this.props.bufferState.goldAmpWash.valueMl }))),
                    React.createElement(Grid.Column, { only: "tablet computer" }),
                    priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.effectivePriceCents, listPriceCents: this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents))),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.bufferState.customPrice, defaultEffectivePriceCents: this.props.effectivePriceCents, errors: this.props.errors, errorPathPrefix: '/buffersComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    return BufferForm;
}(React.PureComponent));
export default BufferForm;
//# sourceMappingURL=BufferForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/secondary-if/BufferForm.js
// module id = 1149
// module chunks = 0